import Layout from '../../components/base/Layout';
import { Link } from 'react-router-dom';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Quiz3() {
  const { t } = useTranslation();
  const [answers, setAnswers] = useState<{[key: number]: string}>({});
  const [showResults, setShowResults] = useState(false);
  const [score, setScore] = useState(0);

  const questions = [
    {
      id: 1,
      question: t('quiz3_q1'),
      options: {
        A: t('quiz3_q1_a'),
        B: t('quiz3_q1_b'),
        C: t('quiz3_q1_c')
      },
      correct: "B"
    },
    {
      id: 2,
      question: t('quiz3_q2'),
      options: {
        A: t('quiz3_q2_a'),
        B: t('quiz3_q2_b'),
        C: t('quiz3_q2_c')
      },
      correct: "B"
    },
    {
      id: 3,
      question: t('quiz3_q3'),
      options: {
        A: t('quiz3_q3_a'),
        B: t('quiz3_q3_b'),
        C: t('quiz3_q3_c')
      },
      correct: "B"
    },
    {
      id: 4,
      question: t('quiz3_q4'),
      options: {
        A: t('quiz3_q4_a'),
        B: t('quiz3_q4_b'),
        C: t('quiz3_q4_c')
      },
      correct: "B"
    },
    {
      id: 5,
      question: t('quiz3_q5'),
      options: {
        A: t('quiz3_q5_a'),
        B: t('quiz3_q5_b'),
        C: t('quiz3_q5_c')
      },
      correct: "B"
    },
    {
      id: 6,
      question: t('quiz3_q6'),
      options: {
        A: t('quiz3_q6_a'),
        B: t('quiz3_q6_b'),
        C: t('quiz3_q6_c')
      },
      correct: "B"
    },
    {
      id: 7,
      question: t('quiz3_q7'),
      options: {
        A: t('quiz3_q7_a'),
        B: t('quiz3_q7_b'),
        C: t('quiz3_q7_c')
      },
      correct: "B"
    },
    {
      id: 8,
      question: t('quiz3_q8'),
      options: {
        A: t('quiz3_q8_a'),
        B: t('quiz3_q8_b'),
        C: t('quiz3_q8_c')
      },
      correct: "B"
    },
    {
      id: 9,
      question: t('quiz3_q9'),
      options: {
        A: t('quiz3_q9_a'),
        B: t('quiz3_q9_b'),
        C: t('quiz3_q9_c')
      },
      correct: "B"
    },
    {
      id: 10,
      question: t('quiz3_q10'),
      options: {
        A: t('quiz3_q10_a'),
        B: t('quiz3_q10_b'),
        C: t('quiz3_q10_c')
      },
      correct: "B"
    }
  ];

  const handleAnswerChange = (questionId: number, answer: string) => {
    setAnswers(prev => ({
      ...prev,
      [questionId]: answer
    }));
  };

  const calculateScore = () => {
    let correctAnswers = 0;
    questions.forEach(question => {
      if (answers[question.id] === question.correct) {
        correctAnswers++;
      }
    });
    setScore(correctAnswers);
    setShowResults(true);
  };

  const resetQuiz = () => {
    setAnswers({});
    setShowResults(false);
    setScore(0);
  };

  const getFeedback = () => {
    if (score >= 8) return t('quiz_excellent');
    if (score >= 6) return t('quiz_good');
    return t('quiz_review');
  };

  return (
    <Layout>
      <div className="max-w-4xl mx-auto space-y-8">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-800 mb-4">
            {t('quiz3_title')}
          </h1>
          <p className="text-xl text-gray-600">
            {t('home_quizzes')}
          </p>
        </div>

        {!showResults ? (
          <div className="space-y-8">
            {questions.map((question, index) => (
              <div key={question.id} className="bg-white rounded-xl p-6 shadow-lg">
                <h3 className="text-lg font-semibold mb-4">
                  {index + 1}. {question.question}
                </h3>
                <div className="space-y-3">
                  {Object.entries(question.options).map(([key, value]) => (
                    <label key={key} className="flex items-center space-x-3 cursor-pointer hover:bg-gray-50 p-3 rounded-lg transition-colors">
                      <input
                        type="radio"
                        name={`question-${question.id}`}
                        value={key}
                        checked={answers[question.id] === key}
                        onChange={() => handleAnswerChange(question.id, key)}
                        className="w-4 h-4 text-purple-600"
                      />
                      <span className="font-medium text-purple-600">{key})</span>
                      <span>{value}</span>
                    </label>
                  ))}
                </div>
              </div>
            ))}

            <div className="text-center">
              <button
                onClick={calculateScore}
                disabled={Object.keys(answers).length < questions.length}
                className="bg-purple-600 text-white px-8 py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors disabled:bg-gray-400 disabled:cursor-not-allowed whitespace-nowrap"
              >
                {t('quiz_submit')}
              </button>
            </div>
          </div>
        ) : (
          <div className="bg-white rounded-xl p-8 shadow-lg">
            <div className="text-center mb-8">
              <div className={`w-24 h-24 mx-auto rounded-full flex items-center justify-center mb-4 ${
                score >= 8 ? 'bg-green-100' : score >= 6 ? 'bg-yellow-100' : 'bg-red-100'
              }`}>
                <span className={`text-3xl font-bold ${
                  score >= 8 ? 'text-green-600' : score >= 6 ? 'text-yellow-600' : 'text-red-600'
                }`}>
                  {score}/{questions.length}
                </span>
              </div>
              <h2 className="text-2xl font-bold mb-2">{t('quiz_score')}</h2>
              <p className={`text-lg ${
                score >= 8 ? 'text-green-600' : score >= 6 ? 'text-yellow-600' : 'text-red-600'
              }`}>
                {getFeedback()}
              </p>
              <p className="text-gray-600 mt-2">
                {score} {t('quiz_correct')} {questions.length}
              </p>
              
              {score >= 8 && (
                <div className="mt-6 p-4 bg-green-50 rounded-lg">
                  <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center">
                    <i className="ri-medal-line text-6xl text-yellow-500"></i>
                  </div>
                  <h3 className="text-xl font-bold text-green-800 mb-2">🎉 {t('quiz_excellent')} 🎉</h3>
                </div>
              )}
            </div>

            <div className="flex justify-center space-x-4 mt-8">
              <button
                onClick={resetQuiz}
                className="bg-gray-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-gray-700 transition-colors whitespace-nowrap"
              >
                {t('quiz_retry')}
              </button>
              <Link
                to="/"
                className="bg-purple-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-purple-700 transition-colors whitespace-nowrap cursor-pointer"
              >
                {t('nav_home')}
              </Link>
            </div>
          </div>
        )}

        <div className="flex justify-between items-center">
          <Link 
            to="/quiz2"
            className="flex items-center text-purple-600 hover:text-purple-700 cursor-pointer"
          >
            <div className="w-5 h-5 flex items-center justify-center mr-2">
              <i className="ri-arrow-left-line"></i>
            </div>
            {t('nav_quiz2')}
          </Link>
          <Link 
            to="/"
            className="flex items-center text-purple-600 hover:text-purple-700 cursor-pointer"
          >
            {t('nav_home')}
            <div className="w-5 h-5 flex items-center justify-center ml-2">
              <i className="ri-home-line"></i>
            </div>
          </Link>
        </div>
      </div>
    </Layout>
  );
}